export enum TrackingType {
  NodeTimeSpent = 'NodeTimeSpent',
  NodeClick = 'NodeClick',
  SectionTimeSpent = 'SectionTimeSpent',
}
